import { render, staticRenderFns } from "./FileMetadata.vue?vue&type=template&id=9e0c7046&scoped=true"
import script from "./FileMetadata.vue?vue&type=script&lang=ts"
export * from "./FileMetadata.vue?vue&type=script&lang=ts"
import style0 from "./FileMetadata.vue?vue&type=style&index=0&id=9e0c7046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0c7046",
  null
  
)

export default component.exports